import React from "react"
import { Article } from "../../Model/Article"
import { Link } from "react-router-dom"
import { getUserLang } from "../../Utils/utiltyHelper"
import { useSelector } from "react-redux"
import classNames from "classnames"

const ArticleCard = ({
  article,
  isCarousel,
}: {
  article: Article
  isCarousel: boolean
}) => {
  const screenWidth = useSelector((state: any) => {
    return state.SystemManager.screenWidth
  })
  return (
    <div
      className={classNames(
        "cursor-pointer",
        isCarousel ? "max-w-xs" : "max-w-sm"
      )}>
      <Link to={"/" + getUserLang() + "/blog/" + article.urlTitle}>
        <div
          className={classNames(
            "md:block",
            isCarousel ? "block" : " grid grid-cols-2 gap-2"
          )}>
          <section className="md:my-0 my-2">
            <img
              style={
                screenWidth < 768
                  ? { width: "300px", height: "150px" }
                  : { width: "380px", height: "250px" }
              }
              className="object-cover rounded-xl"
              src={article.featureImage}
            />
          </section>
          <section className="my-4 md:mx-0.5 mx-2">
            <h3 className=" md:text-lg text-sm font-semibold h-fit overflow-hidden ">
              {article.title}
            </h3>
            <p>
              <span className="uppercase md:text-xs text-2xs font-bold text-gray-400 border-r-2 pr-2 border-r-gray-400">
                {article.authorName}
              </span>
              <span className="uppercase md:text-xs text-2xs font-bold text-gray-400 pl-2">
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/*@ts-ignore*/}
                {new Date(article.publishDate.seconds * 1000).toDateString()}
              </span>
            </p>
          </section>
        </div>
      </Link>
    </div>
  )
}

export default ArticleCard
